const normalizeBaseUrl = (value) => {
  if (typeof value !== 'string') return ''

  const trimmed = value.trim()
  if (!trimmed) return ''

  try {
    const parsed = new URL(trimmed)
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return ''
    }

    const pathname = parsed.pathname.replace(/\/+$/, '')
    return `${parsed.origin}${pathname}`
  } catch {
    return ''
  }
}

const getWindowOrigin = () => {
  if (typeof window === 'undefined' || !window.location?.origin) {
    return ''
  }

  return normalizeBaseUrl(window.location.origin)
}

export const getAppBaseUrl = () => {
  const configured = normalizeBaseUrl(process.env.REACT_APP_APP_URL)
  if (configured) return configured

  return getWindowOrigin()
}

const normalizePath = (path) => {
  if (typeof path !== 'string') return '/'
  if (!path.trim()) return '/'
  return path.startsWith('/') ? path : `/${path}`
}

export const buildAppRedirectUrl = (path) => {
  const baseUrl = getAppBaseUrl()
  if (!baseUrl) return ''

  return `${baseUrl}${normalizePath(path)}`
}

export const getPasswordResetRedirectUrl = () => buildAppRedirectUrl('/update-password')

export const getSignupEmailRedirectUrl = () => buildAppRedirectUrl('/?auth=confirmed')
